import { useEffect } from 'react';
import { waitForAppReady, dispose as disposeApp } from './appContext';
export const useAppLifecycle = () => {
    useEffect(() => {
        // init app (WASM, viewer modules)
        waitForAppReady();
        // dispose on unmount
        return () => {
            disposeApp();
        };
    }, []);
};
